import { useNavigate } from "react-router-dom";

/**
 * UpgradePrompt — Feb 6, 2026.
 *
 * In-page upgrade card. Lives WHERE a tier-gated capability would
 * otherwise sit. Owner directive (Feb 6, 2026):
 *   "Maintain a stable interface while progressively unlocking
 *    capability. Users should feel guided, not restricted."
 *   "DO NOT remove or hide tiles. Gate functionality INSIDE the
 *    pages. ONE clean upgrade card where advanced tools would be."
 *
 * Usage:
 *   <UpgradePrompt
 *     title="Fill gaps"
 *     upgradeTier="Growth"
 *     bullets={["Recover empty slots", "Increase weekly earnings"]}
 *   />
 */
export default function UpgradePrompt({ title, upgradeTier, bullets = [], testId = "upgrade-prompt" }) {
  const nav = useNavigate();
  return (
    <div
      data-testid={testId}
      className="w-full rounded-2xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-4 shadow-sm"
    >
      {title ? (
        <p className="text-base font-extrabold text-slate-900 dark:text-white leading-tight mb-2">{title}</p>
      ) : null}
      <p className="text-xs font-bold text-slate-700 dark:text-slate-200 mb-1.5">
        Upgrade to {upgradeTier} to:
      </p>
      <ul className="space-y-1 mb-3">
        {bullets.map((b, i) => (
          <li key={i} className="text-xs text-slate-600 dark:text-slate-300 leading-snug pl-3 relative">
            <span className="absolute left-0 top-2 w-1 h-1 rounded-full bg-slate-400" />
            {b}
          </li>
        ))}
      </ul>
      <button
        data-testid={`${testId}-cta`}
        onClick={() => nav("/pricing")}
        className="w-full h-10 rounded-xl bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-sm font-bold hover:bg-slate-800 dark:hover:bg-slate-100 transition-colors"
      >
        View plans
      </button>
    </div>
  );
}
